import {Component} from '@angular/core';
import {Pessoa} from "../../../../domain/Pessoa";
import {Funcao} from "../../../../domain/enums";
import {AbstractEditOrmComponent} from "../../AbstractEditOrmComponent";
import {EnumSincronizacao} from "../../../../domain/EnumSincronizacao";

@Component({
  selector: 'app-pessoa',
  templateUrl: './pessoa.component.html',
  styleUrls: ['./pessoa.component.scss'],
})
export class PessoaComponent extends AbstractEditOrmComponent<Pessoa>  {
  funcoes= Object.values(Funcao)
  urlListagem = "/cadastro/pessoa"

  agenciavel = true
  target = Pessoa

  protected override async saveInternal(): Promise<void> {
    this.entidade.situacao = EnumSincronizacao.ENVIAR
    await super.saveInternal()
  }
}
